// extracted by mini-css-extract-plugin
module.exports = {"matchWrapper":"MatchSetup_matchWrapper__3EaO8","headerWrapper":"MatchSetup_headerWrapper__1voPV"};